module.exports = __webpack_public_path__ + "img/1.5k.5bbe36a5.png";